// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2sV1v","errors":"Errors_errors__1neH_"};